import {
  formatCurrency,
  formatDateOnly,
  MONEY_STATE_LABELS,
  type InstallmentState,
  type LineMoney,
} from '@peles/shared';

/** The `StatusBadge` colour of where a line's money stands. */
export const MONEY_STATE_COLORS = {
  unpaid: 'gray',
  partly_paid: 'yellow',
  paid: 'green',
  overpaid: 'purple',
} as const;

export const INSTALLMENT_STATE_LABELS: Record<InstallmentState, string> = {
  paid: 'Paid',
  partly_paid: 'Partly paid',
  due: 'Due',
  overdue: 'Overdue',
};

export const INSTALLMENT_STATE_COLORS: Record<InstallmentState, string> = {
  paid: 'green',
  partly_paid: 'yellow',
  due: 'gray',
  overdue: 'red',
};

/** "Oct 1" — a stored `YYYY-MM-DD` read as the day it names. */
export function shortDate(day: string | null | undefined): string {
  return day ? formatDateOnly(day, { month: 'short', day: 'numeric' }) : '';
}

/** The badge a line wears: overdue before anything else, then its state. */
export function moneyBadge(money: LineMoney): { label: string; color: string } {
  if (money.overdue) return { label: 'Overdue', color: 'red' };
  return { label: MONEY_STATE_LABELS[money.state], color: MONEY_STATE_COLORS[money.state] };
}

/** "$1,290 · Oct 1", or "—" when nothing is owed or it has no day. */
export function describeNextDue(money: LineMoney): string {
  if (!money.nextDue) return '—';
  const amount = formatCurrency(money.nextDue.amount);
  return money.nextDue.date ? `${amount} · ${shortDate(money.nextDue.date)}` : amount;
}
